import { companyService } from 'hq/services';
import { useMutation, UseMutationOptions, useQueryClient } from 'react-query';
import { QUERY_KEYS } from 'api/query-keys';
import { CreateCompanyOrt } from '@types';

type CompanyOrtMutationOptions = UseMutationOptions<unknown, unknown, CreateCompanyOrt>;

export const useCreateCompanyOrt = (companyId: string) => {
  const mutationFn = async (ort: CreateCompanyOrt) =>
    await companyService.createOrt(companyId, ort);

  const queryClient = useQueryClient();
  const mutationOptions: CompanyOrtMutationOptions = {
    onSuccess: async () => {
      await queryClient.invalidateQueries(QUERY_KEYS.orts());
    },
  };

  return useMutation(mutationFn, mutationOptions);
};
